<h1 class="stock-title">Stock Replenishment</h1>

<app-breadcrumb></app-breadcrumb>

<br />
<div class="mt-3"></div>
<br />

<app-replenishment-stock-filters></app-replenishment-stock-filters>

<br />
<div class="mt-3"></div>
<br />
